function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuotationMarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 44 34"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25 24.7a9.23 9.23 0 009.49 9.3A9.16 9.16 0 0044 24.7a9.62 9.62 0 00-6.72-9L42.73 0h-7.61L26 20.37a10.89 10.89 0 00-1 4.33zm-25 0A9.23 9.23 0 009.51 34 9.16 9.16 0 0019 24.7a9.62 9.62 0 00-6.72-9L17.75 0h-7.61L1 20.37a10.89 10.89 0 00-1 4.33z",
    style: {
      isolation: "isolate"
    }
  }));
}

export default SvgQuotationMarks;